<template>

  <div class="flex flex-col">
    <div v-if="!itemData.fromDB" class="flex flex-col flex-1 px-2 pt-4 md:pt-5 md:px-1">
      <div class="flex-1 text-sm font-bold leading-snug md:text-base">
        {{ $t("main.specialProduct") }}
      </div>
    </div>

    <a v-else :href="externalURL" target="_blank" rel="noopener" class="flex flex-col flex-1 p-3 mx-3 mt-2 mb-1 transition-shadow duration-150 bg-white rounded-sm shadow-lg md:p-5 md:mt-3 md:mb-3 hover:shadow-2xl">
      <header class="mb-0 -m-3 leading-tight md:-m-5 md:mb-0">Art.-Nr. {{ itemData.code }}</header>
      <img :src="itemData.fromDB.product_image" :alt="itemData.label" class="mx-auto"/>
      <div class="text-sm leading-tight text-gray-500">{{ itemData.fromDB.product_categories[0].title }}</div>
      <div class="flex-1 mt-2 font-bold leading-tight font-eurostile text-lightblue md:mt-2">
        {{ itemData.label }}
      </div>
    </a>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import getExternalProductLink from '@/util/get-external-product-link';

export default {
  props: {
    itemData: {
      required: true,
      type: Object
    }
  },
  computed: {
    ...mapState(['language']),
    externalURL () {
      return getExternalProductLink({ articleNumber: this.itemData.fromDB.article_number, locale: this.$i18n.locale, label: this.itemData.label });
    }
  }
};
</script>

<style lang="postcss" scoped>
header {
  @apply block text-sm px-2 py-1 text-white;
  background: linear-gradient(
    145deg,
    theme("colors.darkblue") 0%,
    theme("colors.lightblue") 100%
  );
  clip-path: polygon(0 0, 100% 0%, calc(100% - 15px) 100%, 0% 100%);
}
</style>
